/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Resize_TooltipInputs */



/**
* | output |
* | --- |
* | "Drag to resize · Double-click to reset" |
*
* @param {Artifact_Resize_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_resize_tooltip = /** @type {((inputs?: Artifact_Resize_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Resize_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ziehen zum Ändern der Größe · Doppelklick zum Zurücksetzen")
	return /** @type {LocalizedString} */ ("Drag to resize · Double-click to reset")
});